// @ts-nocheck - TODO: Fix type errors once API client is fully migrated in Phase 4
import type { TagOption } from "../chakraUI/TagList";
import type { Competence, VisitingAddress } from "../models/Order";
import type { OoUserService } from "../networking/generated/api-client";

export const getAddress = (address?: VisitingAddress): string => {
	const addressParts = [];
	if (!address) return "";
	if (address.address1) {
		addressParts.push(address.address1);
	}

	if (address.address2) {
		addressParts.push(address.address2);
	}

	if (address.country) {
		addressParts.push(address.country);
	}

	return addressParts.join(", ");
};

export const extractSkills = (objects: Competence[]): TagOption[] => {
	const skillSet = new Set<string>();

	for (const obj of objects) {
		if (obj.skills) {
			obj.skills.forEach((skill) => skillSet.add(skill));
		}
	}
	return Array.from(skillSet).map((item) => ({
		key: item,
		value: convertToSentenceCase(item),
	}));
};

const convertToSentenceCase = (input: string): string => {
	return input.replace(/\b\w/g, (match) => match.toUpperCase());
};

export const getNotificationSettingList = (
	selectedCustomer: string,
	customerList?: OoUserService.GetCustomeraccountUserIdCustomerResponse["customers"],
): string[] => {
	const customerNotificationSettings = customerList?.find((c) => c.id === selectedCustomer)?.notificationSetting ?? {};
	const settingList: string[] = [];
	if (Object.keys(customerNotificationSettings).length > 0) {
		for (const key in customerNotificationSettings) {
			// @ts-ignore
			if (customerNotificationSettings[key]) {
				settingList.push(key);
			}
		}
		return settingList;
	}
	return [];
};
